import { Component } from '@angular/core';
import { BasicDialogComponent } from '@shared/components/dialogs/basic-dialog.component';

@Component({
    standalone: false,
    selector: 'app-subnational-territorial-entity-dialog',
    templateUrl: './subnational-territorial-entity-dialog.component.html'
})
export class SubnationalTerritorialEntityDialogComponent extends BasicDialogComponent {

    constructor() {
        super();
    }
}
